import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import IframeResizer from 'iframe-resizer-react';
import translateObj from '../../util/translateObj';

const IframeComponent = ({ url, fullWidth, match, useLang, attributes }) => {
  let urlObj = url;
  if (typeof url === 'string') {
    urlObj = {
      en: url,
    };
  }
  const { params: { lang } } = match;

  // Build the URL with lang parameter if useLang is true
  let finalUrl = translateObj(urlObj, lang);
  if (useLang && lang) {
    const separator = finalUrl.includes('?') ? '&' : '?';
    finalUrl = `${finalUrl}${separator}lang=${lang}`;
  }

  // Parse attributes if it's a string
  const parsedAttributes = {};
  if (attributes && typeof attributes === 'string') {
    // Simple parsing for attributes like 'allow="payment"'
    const matches = attributes.match(/(\w+)="([^"]+)"/g);
    if (matches) {
      matches.forEach((attrMatch) => {
        const [, key, value] = attrMatch.match(/(\w+)="([^"]+)"/);
        parsedAttributes[key] = value;
      });
    }
  } else if (attributes && typeof attributes === 'object') {
    Object.assign(parsedAttributes, attributes);
  }

  return (
    <div className={`${fullWidth ? 'full-width' : 'w-full'}`}>
      {finalUrl.includes('goosebumps.primaverasound.com')
        ? (
          <div className="bg-white">
            <IframeResizer
              src={finalUrl}
              style={{ width: '1px', minWidth: '100%' }}
              heightCalculationMethod="taggedElement"
              allow={parsedAttributes.allow}
            />
          </div>
        ) : (
          <div className="iframe-container w-full">
            <iframe
              title="iframe"
              src={finalUrl}
              frameBorder="0"
              allow={parsedAttributes.allow}
            />
          </div>
        )}
    </div>
  );
};

IframeComponent.propTypes = {
  url: PropTypes.shape(),
  fullWidth: PropTypes.bool,
  match: PropTypes.shape().isRequired,
  useLang: PropTypes.bool,
  attributes: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
};

IframeComponent.defaultProps = {
  url: { en: 'https://map.closer2event.com/?event=primaverasound' },
  fullWidth: true,
  useLang: false,
  attributes: undefined,
};

export default withRouter(IframeComponent);
